export enum TrendingResult {
  Modern = 'Modern', // Uses search to find SharePoint default trending results from team sites and communication sites (the same way as SharePoint Home does it).
  ModernOnlyFromCoreRootSite = 'ModernOnlyFromCoreRootSite' // Same as 'Modern' but limited to only return trending results from the root site
}
